import FacebookProductSetCard from './FacebookProductSetCard';

const FacebookProductSetCards = ({ facebookProductSets }) => {
  return facebookProductSets.map((facebookProductSet) => {
    return <FacebookProductSetCard key={facebookProductSet.id} facebookProductSet={facebookProductSet} />;
  });
};

export default FacebookProductSetCards;
